module.exports = __webpack_public_path__ + "img/GH-kyujin-programmer003.5030f3a8.webp";